import { useRouter } from 'next/router'
import { useEffect } from 'react'

import API from 'api'
import { getPayBySignageUrl } from 'models/payBySignage'

const PayBySignage = () => {
  const router = useRouter()
  const { lotId, user_data } = router.query

  useEffect(() => {
    const handleRedirect = async () => {
      if (!lotId) return

      try {
        const { lot } = await API().getLot(lotId)

        if (!lot || lot?.error) {
          window.location.href = 'https://www.citifyd.com/park'
        } else {
          const payBySignageUrl = getPayBySignageUrl(lot)
          const destination = user_data
            ? `/parking-lots/${payBySignageUrl}?user_data=${user_data}`
            : `/parking-lots/${payBySignageUrl}`

          router.replace(destination)
        }
      } catch (err) {
        window.location.href = 'https://www.citifyd.com/park'
      }
    }

    handleRedirect()
  }, [lotId, user_data])

  return <div>Redirecionando...</div>
}

export default PayBySignage
